$(document).ready(function () {

	
	/////////////////////////////////////////
	// Toggle nav menu ///////////////////
	/////////////////////////////////////////

	$('.button-mobile-nav').click(function () {
		$('body').toggleClass('show-nav');
		$('.button-mobile-nav i').toggleClass('fa-bars');
		$('.button-mobile-nav i').toggleClass('fa-times');
		
	})
	
	// Toggle submenu.
	$('nav ul li a').click(function (e) {
		var subItems = $(this).parent().find('ul').length;
		if (subItems >= 1) {
			e.preventDefault();
			$('.show-child').removeClass('show-child');
			$(this).parent().addClass('show-child');
		}
	})

	// touche close menu when swipe to right
	// $('nav nav').on('touchstart', function (e) {
	// 	var swipe = e.originalEvent.touches;
	// 	var start = swipe[0].pageX;
	// 	$(this).on('touchmove', function (e) {
	// 		var contact = e.originalEvent.touches;
	// 		var end = contact[0].pageX;
	// 		var distance = end - start;
	// 		if (distance > 70) {
	// 			$('nav').removeClass('show');
	// 		}
	// 	});
	// });

});



// WEBPACK FOOTER //
// ./resources/js/menu.js